import ko from "knockout";
import manifestManager from "flow/utils/manifestManager";
import config from "flow/config";
import viewCache from "flow/utils/viewCache";
import { CloseCallback } from "flow/api/types";
import viewHtml from "./ConfirmDialog.html";

// I create my own manifest
manifestManager.addManifests(config.moduleId, [
    {
        id: config.componentIds.confirm,
        isDialog: true,
        namespace: "default",
        reuseInstance: false,
        useFormValidation: false,
        viewModelId: "flow/viewModels/ConfirmDialog",
        viewUrl: "virtual/ConfirmDialog"
    }
]);

viewCache.inject("virtual/ConfirmDialog", viewHtml);

export interface IConfirmDialogViewContext {
    title: string;
    text: string;
    buttons: string[];
}

function ConfirmDialog() {
    let closeFunc: CloseCallback;
    const text = ko.observable();
    const commands = ko.observableArray();
    const title = ko.observable();
    const focusObservable = ko.observable();

    function activate(viewContext: IConfirmDialogViewContext, closeCallback: CloseCallback) {
        closeFunc = closeCallback;
        title(viewContext.title);
        text(viewContext.text);

        const commandList = [
            { text: viewContext.buttons[0], click: firstChoice, focusObs: focusObservable },
            { text: viewContext.buttons[1], click: secondChoice }
        ];

        if (viewContext.buttons.length === 3) {
            commandList.push({ text: viewContext.buttons[2], click: thirdChoice });
        }

        commands(commandList);

        focusObservable(true);
    }

    function firstChoice() {
        closeFunc(true);
    }

    function secondChoice() {
        closeFunc(false);
    }

    function thirdChoice() {
        closeFunc(undefined);
    }

    function getDimensions(maxWidth: number, _maxHeight: number) {
        return {
            width: Math.min(maxWidth - 24, 600),
            height: "auto"
        };
    }

    return {
        commands: commands,
        activate: activate,
        componentTitle: title,
        text: text,
        getDimensions: getDimensions
    };
}

export default ConfirmDialog;
